module.exports = __webpack_public_path__ + "static/media/empty-avatar.346b0483.jpg";